import Header from "../pages/Header";
import Footer from "./Footer";
import Config from "./Config";
import styles from "../pages/TermsofUse.module.css";
import logo from "../media/cart7_logo_black.png";

function TermsofUse () {
  return(
    <>
    <Header />
    <div className={styles.fullWrapper}>
      <div className={styles.container}>
        <div  className={styles.logo}><img src={logo} alt="logo" /></div>
        <h2>Terms of Use</h2>

<h3>Last Updated: [14 March 2026]</h3>

Welcome to [{Config.siteName}]. By accessing or using our website, you agree to comply with and be bound by the following Terms of Use. Please read them carefully before using our services.

<h3>1. Acceptance of Terms</h3>

By accessing this website and placing orders through it, you agree to these Terms of Use and all applicable laws and regulations. If you do not agree with any part of these terms, please do not use our website.

<h3>2. Use of the Website</h3>

You agree to use this website only for lawful purposes. You must not:

Use the website in any way that may damage or disrupt the service.

Attempt to gain unauthorized access to any part of the website or its systems.

Use the website to distribute malicious software or harmful content.

<h3>3. Product Information</h3>

We strive to ensure that all product descriptions, images, and prices displayed on the website are accurate. However, errors may occur. We reserve the right to correct any errors and update product information without prior notice.

<h3>4. Orders and Payments</h3>

When you place an order on our website:

You agree that the information provided is accurate and complete.

All orders are subject to availability and acceptance.

We reserve the right to cancel or refuse any order if necessary.

Payments must be completed through the available payment methods before an order is processed.

<h3>5. Pricing</h3>

All prices listed on the website are subject to change without notice. We reserve the right to update pricing at any time.

<h3>6. Shipping and Delivery</h3>

Delivery times are estimates and may vary depending on location and logistics conditions. We are not responsible for delays caused by third-party shipping providers.

<h3>7. Returns and Refunds</h3>

Returns and refunds are subject to our Return and Refund Policy. Please review that policy for more details about eligibility and procedures.

<h3>8. Intellectual Property</h3>

All content on this website, including text, images, logos, and design elements, is the property of [{Config.siteName}] and is protected by applicable copyright and intellectual property laws. Unauthorized use is prohibited.

<h3>9. Limitation of Liability</h3>

We are not responsible for any direct, indirect, or incidental damages resulting from the use or inability to use our website or services.

<h3>10. Third-Party Services</h3>

Our website may use or link to third-party services such as payment providers or delivery services. We are not responsible for the policies or actions of these third parties.

<h3>11. Changes to These Terms</h3>

We may update these Terms of Use from time to time. Any changes will be posted on this page with an updated revision date.

<h3>12. Contact Us</h3>

If you have any questions regarding these Terms of Use, you may contact us through our WhatsApp support available on the website.
      </div>
    </div>
    <Footer />
    </>
    );
}
export default TermsofUse;